import HotTub from '@material-ui/icons/HotTub'
import { logAmplitudeEvent } from 'amplitude/amplitude'
import { authSelectors } from 'ducks/auth'
import FullScreenLoading from 'layout/widgets/FullScreenLoading'
import React, { useCallback, useEffect, useMemo } from 'react'
import { useAuth } from 'react-oidc-context'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { parseQueryStringToDictionary } from 'util/misc'
import { AFTER_CONNECT_REDIRECT_URL } from './constants'
import useSaveAccessTokensAfterLogin from './sync/useSaveAccessTokensAfterLogin'

const CityPlumbingAfterConnectPage = React.memo(() => {
  const auth = useAuth()
  const history = useHistory()
  const location = useLocation()
  const orgId = useSelector(authSelectors.getOrgId)
  const { isSyncing, saveAccessTokens } = useSaveAccessTokensAfterLogin()
  const params = parseQueryStringToDictionary(location.search)
  const redirect_url = params?.redirect_url ? AFTER_CONNECT_REDIRECT_URL[params?.redirect_url] : '/shop'

  const initialising = useMemo(() => {
    return auth?.isLoading || isSyncing
  }, [isSyncing, auth])

  const doSync = useCallback(
    async (orgId, refreshToken) => {
      if (orgId && refreshToken) {
        await saveAccessTokens({ orgId, refreshToken, supplierFilterKey: 'city_plumbing' })
        history.push({ pathname: redirect_url, state: { from: '/shop/after_connect/city_plumbing' } })
      }
    },
    [orgId]
  )

  useEffect(() => {
    if (orgId && auth?.user?.refresh_token) {
      doSync(orgId, auth.user.refresh_token)
    }
  }, [orgId, auth?.user])

  if (initialising) {
    return <FullScreenLoading />
  }

  return <></>
})

const AfterConnectPage = (props) => {
  const distributor = props?.match?.params?.distributor
  const orgId = useSelector(authSelectors.getOrgId)

  useEffect(() => {
    logAmplitudeEvent('hardware_distributor_connection_completed', { supplier: distributor, orgId })
  }, [distributor, orgId])

  switch (distributor) {
    case 'city_plumbing':
      return <CityPlumbingAfterConnectPage />
    default:
      return <HotTub />
  }
}

export default AfterConnectPage
